"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
const core_1 = require("@smash-sdk/core");
const ChangePasswordError_1 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_2 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_3 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_4 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_5 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_6 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_7 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_8 = require("./types/ChangePassword/ChangePasswordError");
const CreateTokenError_1 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_2 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_3 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_4 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_5 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_6 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_7 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_8 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_9 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_10 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_11 = require("./types/CreateToken/CreateTokenError");
const ForgotPasswordError_1 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_2 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_3 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_4 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_5 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_6 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_7 = require("./types/ForgotPassword/ForgotPasswordError");
const GetSigninConfigurationError_1 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetSigninConfigurationError_2 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetSigninConfigurationError_3 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetSigninConfigurationError_4 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetSigninConfigurationError_5 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetSigninConfigurationError_6 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const ResetPasswordError_1 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_2 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_3 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_4 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_5 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_6 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_7 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_8 = require("./types/ResetPassword/ResetPasswordError");
const SsoSigninError_1 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_2 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_3 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_4 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_5 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_6 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_7 = require("./types/SsoSignin/SsoSigninError");
exports.errors = {
    ChangePassword: {
        InvalidParameterError: ChangePasswordError_2.InvalidParameterError,
        InvalidSecretError: ChangePasswordError_3.InvalidSecretError,
        ExpiredSecretError: ChangePasswordError_4.ExpiredSecretError,
        NotFoundError: ChangePasswordError_5.NotFoundError,
        InternalServerError: ChangePasswordError_6.InternalServerError,
        BadGatewayError: ChangePasswordError_7.BadGatewayError,
        GatewayTimeoutError: ChangePasswordError_8.GatewayTimeoutError,
        GenericError: ChangePasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateToken: {
        InvalidParameterError: CreateTokenError_2.InvalidParameterError,
        InvalidCredentialsError: CreateTokenError_3.InvalidCredentialsError,
        PasswordRevokedError: CreateTokenError_4.PasswordRevokedError,
        IdentityDisabledError: CreateTokenError_5.IdentityDisabledError,
        InvalidAuthenticationModeError: CreateTokenError_6.InvalidAuthenticationModeError,
        NotFoundError: CreateTokenError_7.NotFoundError,
        ConflictError: CreateTokenError_8.ConflictError,
        InternalServerError: CreateTokenError_9.InternalServerError,
        BadGatewayError: CreateTokenError_10.BadGatewayError,
        GatewayTimeoutError: CreateTokenError_11.GatewayTimeoutError,
        GenericError: CreateTokenError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ForgotPassword: {
        InvalidParameterError: ForgotPasswordError_2.InvalidParameterError,
        InvalidIdentityUsernameError: ForgotPasswordError_3.InvalidIdentityUsernameError,
        NotFoundError: ForgotPasswordError_4.NotFoundError,
        InternalServerError: ForgotPasswordError_5.InternalServerError,
        BadGatewayError: ForgotPasswordError_6.BadGatewayError,
        GatewayTimeoutError: ForgotPasswordError_7.GatewayTimeoutError,
        GenericError: ForgotPasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetSigninConfiguration: {
        InvalidParameterError: GetSigninConfigurationError_2.InvalidParameterError,
        NotFoundError: GetSigninConfigurationError_3.NotFoundError,
        InternalServerError: GetSigninConfigurationError_4.InternalServerError,
        BadGatewayError: GetSigninConfigurationError_5.BadGatewayError,
        GatewayTimeoutError: GetSigninConfigurationError_6.GatewayTimeoutError,
        GenericError: GetSigninConfigurationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ResetPassword: {
        InvalidParameterError: ResetPasswordError_2.InvalidParameterError,
        InvalidSecretError: ResetPasswordError_3.InvalidSecretError,
        ExpiredSecretError: ResetPasswordError_4.ExpiredSecretError,
        NotFoundError: ResetPasswordError_5.NotFoundError,
        InternalServerError: ResetPasswordError_6.InternalServerError,
        BadGatewayError: ResetPasswordError_7.BadGatewayError,
        GatewayTimeoutError: ResetPasswordError_8.GatewayTimeoutError,
        GenericError: ResetPasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    SsoSignin: {
        InvalidParameterError: SsoSigninError_2.InvalidParameterError,
        NotFoundError: SsoSigninError_3.NotFoundError,
        ConflictError: SsoSigninError_4.ConflictError,
        InternalServerError: SsoSigninError_5.InternalServerError,
        BadGatewayError: SsoSigninError_6.BadGatewayError,
        GatewayTimeoutError: SsoSigninError_7.GatewayTimeoutError,
        GenericError: SsoSigninError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ChangePasswordError: {
        InvalidParameterError: ChangePasswordError_2.InvalidParameterError,
        InvalidSecretError: ChangePasswordError_3.InvalidSecretError,
        ExpiredSecretError: ChangePasswordError_4.ExpiredSecretError,
        NotFoundError: ChangePasswordError_5.NotFoundError,
        InternalServerError: ChangePasswordError_6.InternalServerError,
        BadGatewayError: ChangePasswordError_7.BadGatewayError,
        GatewayTimeoutError: ChangePasswordError_8.GatewayTimeoutError,
        GenericError: ChangePasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    CreateTokenError: {
        InvalidParameterError: CreateTokenError_2.InvalidParameterError,
        InvalidCredentialsError: CreateTokenError_3.InvalidCredentialsError,
        PasswordRevokedError: CreateTokenError_4.PasswordRevokedError,
        IdentityDisabledError: CreateTokenError_5.IdentityDisabledError,
        InvalidAuthenticationModeError: CreateTokenError_6.InvalidAuthenticationModeError,
        NotFoundError: CreateTokenError_7.NotFoundError,
        ConflictError: CreateTokenError_8.ConflictError,
        InternalServerError: CreateTokenError_9.InternalServerError,
        BadGatewayError: CreateTokenError_10.BadGatewayError,
        GatewayTimeoutError: CreateTokenError_11.GatewayTimeoutError,
        GenericError: CreateTokenError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ForgotPasswordError: {
        InvalidParameterError: ForgotPasswordError_2.InvalidParameterError,
        InvalidIdentityUsernameError: ForgotPasswordError_3.InvalidIdentityUsernameError,
        NotFoundError: ForgotPasswordError_4.NotFoundError,
        InternalServerError: ForgotPasswordError_5.InternalServerError,
        BadGatewayError: ForgotPasswordError_6.BadGatewayError,
        GatewayTimeoutError: ForgotPasswordError_7.GatewayTimeoutError,
        GenericError: ForgotPasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    GetSigninConfigurationError: {
        InvalidParameterError: GetSigninConfigurationError_2.InvalidParameterError,
        NotFoundError: GetSigninConfigurationError_3.NotFoundError,
        InternalServerError: GetSigninConfigurationError_4.InternalServerError,
        BadGatewayError: GetSigninConfigurationError_5.BadGatewayError,
        GatewayTimeoutError: GetSigninConfigurationError_6.GatewayTimeoutError,
        GenericError: GetSigninConfigurationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    ResetPasswordError: {
        InvalidParameterError: ResetPasswordError_2.InvalidParameterError,
        InvalidSecretError: ResetPasswordError_3.InvalidSecretError,
        ExpiredSecretError: ResetPasswordError_4.ExpiredSecretError,
        NotFoundError: ResetPasswordError_5.NotFoundError,
        InternalServerError: ResetPasswordError_6.InternalServerError,
        BadGatewayError: ResetPasswordError_7.BadGatewayError,
        GatewayTimeoutError: ResetPasswordError_8.GatewayTimeoutError,
        GenericError: ResetPasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    SsoSigninError: {
        InvalidParameterError: SsoSigninError_2.InvalidParameterError,
        NotFoundError: SsoSigninError_3.NotFoundError,
        ConflictError: SsoSigninError_4.ConflictError,
        InternalServerError: SsoSigninError_5.InternalServerError,
        BadGatewayError: SsoSigninError_6.BadGatewayError,
        GatewayTimeoutError: SsoSigninError_7.GatewayTimeoutError,
        GenericError: SsoSigninError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
    },
    InvalidSdkConfigurationError: core_1.InvalidSdkConfigurationError,
    InvalidRegionOrHostError: core_1.InvalidRegionOrHostError,
    InvalidRegionError: core_1.InvalidRegionError,
    InvalidHostError: core_1.InvalidHostError,
};
